<!-- <div class="sp-overlay" *ngIf="open" (click)="closePanel()"></div> -->

<div class="sp-panel" *ngIf="open" role="dialog" aria-modal="true" aria-label="Choose suppliers">
  <div class="sp-panel__bar"></div>
  <app-embedded-loader [show]="loading"></app-embedded-loader>
  <div class="sp-header">
    <div class="sp-header__icon"><mat-icon>how_to_reg</mat-icon></div>
    <div class="sp-header__text">
      <h3 class="sp-header__title">Choose who quotes this RFQ</h3>
      <p class="sp-header__sub">
        <span *ngIf="rfqRefNumber">{{ rfqRefNumber }}</span>
        <span *ngIf="rfqRefNumber" class="sp-dot">·</span>
        <span>{{ chosenCount }} selected</span>
      </p>
    </div>
    <!-- <button type="button" class="sp-close" (click)="closePanel()" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button> -->
  </div>

  <!-- Validation, stated next to the control it belongs to. -->
  <div class="sp-notice" *ngIf="notice" role="alert" aria-live="assertive">
    <div class="sp-notice__icon"><mat-icon>error_outline</mat-icon></div>
    <div>
      <div class="sp-notice__title">{{ notice.title }}</div>
      <div class="sp-notice__detail">{{ notice.detail }}</div>
    </div>
  </div>

  <!-- Onboarding the document's supplier found it already on MPS (2026-10-20): link it, or explicitly create new. -->
  <div class="sp-existing" *ngIf="existingMatches?.length" role="alert" aria-live="polite">
    <div class="sp-notice__title">This supplier may already be on MPS</div>
    <div class="sp-notice__detail">Link the existing account instead of onboarding a second one.</div>
    <div class="sp-existing__row" *ngFor="let m of existingMatches; trackBy: trackByMatch">
      <div class="sp-existing__main">
        <div class="sp-card__name">
          Already on MPS: {{ m.companyName }}<span *ngIf="m.country">&nbsp;({{ m.country }})</span>
          <span class="sp-chip sp-chip--on" *ngIf="m.alreadyLinked">My Suppliers</span>
        </div>
        <div class="sp-existing__why">Matched on {{ reasonLabel(m) }}</div>
      </div>
      <button type="button" class="sp-btn" (click)="linkExisting.emit(m)" [disabled]="loading">
        <mat-icon>link</mat-icon>
        Link
      </button>
    </div>
    <div class="sp-existing__create">
      <button type="button" class="sp-btn sp-btn--ghost" *ngIf="!confirmingCreate && allowCreateNew" (click)="confirmingCreate = true" [disabled]="loading">
        None of these - onboard a new supplier
      </button>
      <span class="sp-existing__why" *ngIf="!allowCreateNew">
        This e-mail address already belongs to a supplier on MPS, so a new account cannot be created with it.
      </span>
      <ng-container *ngIf="confirmingCreate">
        <span class="sp-existing__warn"><mat-icon>warning</mat-icon>Create a second account although the company may already be on MPS?</span>
        <button type="button" class="sp-btn sp-btn--ghost" (click)="confirmingCreate = false">Cancel</button>
        <button type="button" class="sp-btn" (click)="confirmCreateNew()" [disabled]="loading">
          <mat-icon>person_add</mat-icon>
          Yes, create new
        </button>
      </ng-container>
    </div>
  </div>

  <!-- Both pools are MPS suppliers: suggested by product, or already yours. -->
  <div class="sp-tabs" role="tablist">
    <button
      type="button"
      class="sp-tab"
      *ngFor="let t of tabs"
      [class.sp-tab--active]="activeSource === t.key"
      (click)="activeSource = t.key"
      [matTooltip]="t.hint"
      matTooltipPosition="below"
      role="tab"
      [attr.aria-selected]="activeSource === t.key"
    >
      {{ t.label }}
      <span class="sp-tab__n">{{ countFor(t.key) }}</span>
    </button>
  </div>

  <div class="sp-tools">
    <div class="sp-search">
      <mat-icon>search</mat-icon>
      <input
        type="text"
        [(ngModel)]="search"
        placeholder="Filter by company, contact, email or vendor code"
        aria-label="Filter suppliers"
      />
      <button type="button" *ngIf="search" (click)="search = ''" aria-label="Clear filter">
        <mat-icon>close</mat-icon>
      </button>
    </div>
    <button type="button" class="sp-link" (click)="selectAllVisible()" *ngIf="visible.length">
      Select these {{ visible.length }}
    </button>
    <button type="button" class="sp-link" (click)="clearSelection()" *ngIf="chosenCount">
      Clear
    </button>
  </div>

  <div class="sp-body">
    <div class="sp-loading" *ngIf="loading">
      <span class="sp-spinner"></span>
      <span>Looking up suppliers for these items…</span>
    </div>

    <div class="sp-empty" *ngIf="!loading && error">
      <mat-icon>error_outline</mat-icon>
      <div>
        <div class="sp-empty__title">Suppliers could not be loaded</div>
        <div class="sp-empty__detail">{{ error }}</div>
      </div>
    </div>

    <div class="sp-empty" *ngIf="!loading && !error && !visible.length">
      <mat-icon>person_search</mat-icon>
      <div>
        <div class="sp-empty__title">Nothing in {{ sourceLabel(activeSource) }}</div>
        <div class="sp-empty__detail">
          {{ activeSource === 'ai'
              ? 'No MPS supplier lists these exact items yet. Try your own suppliers, or onboard the company you want to ask.'
              : activeSource === 'mapped'
                ? 'No MPS supplier is linked to the same IMPA, ISSA or part numbers yet.'
                : 'You have not onboarded a supplier matching that. Check the suggestions, or onboard a new one.' }}
        </div>
        <button type="button" class="sp-btn sp-btn--small" (click)="onboard.emit()">
          <mat-icon>person_add</mat-icon>
          Onboard a new supplier
        </button>
      </div>
    </div>

    <div
      class="sp-card"
      *ngFor="let s of visible; let i = index; trackBy: trackBySupplier"
      [class.sp-card--chosen]="isChosen(s)"
      [class.sp-card--locked]="s.alreadyAttached"
      [style.animation-delay]="(i < 12 ? i * 35 : 0) + 'ms'"
      (click)="toggle(s)"
    >
      <div class="sp-check" [class.sp-check--on]="isChosen(s) || s.alreadyAttached">
        <mat-icon>{{ isChosen(s) || s.alreadyAttached ? 'check' : 'add' }}</mat-icon>
      </div>

      <div class="sp-card__avatar">{{ initials(s) }}</div>

      <div class="sp-card__main">
        <div class="sp-card__name">
          {{ s.companyName }}
          <span class="sp-chip sp-chip--on" *ngIf="s.alreadyAttached">On this RFQ</span>
          <span class="sp-chip" *ngFor="let src of s.sources">{{ sourceLabel(src) }}</span>
          <span class="sp-chip" *ngIf="s.linesCovered">{{ s.linesCovered }} {{ s.linesCovered === 1 ? 'line' : 'lines' }}</span>
        </div>
        <div class="sp-card__meta">
          <span *ngIf="s.contactPerson"><mat-icon>person</mat-icon>{{ s.contactPerson }}</span>
          <span *ngIf="s.vendorCode"><mat-icon>badge</mat-icon>{{ s.vendorCode }}</span>
          <span *ngIf="s.country"><mat-icon>public</mat-icon>{{ s.country }}</span>
          <span *ngIf="s.email"><mat-icon>mail</mat-icon>
            <a *ngIf="s.email; else noEmail"
            [href]="'mailto:' + s.email">
            </a>
            <ng-template #noEmail>
              -
            </ng-template>
            </span>
          <span *ngIf="s.phone"><mat-icon>call</mat-icon>{{ s.phone }}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="sp-footer">
    <div class="sp-footer__count">
      <strong>{{ chosenCount }}</strong>
      {{ chosenCount === 1 ? 'supplier' : 'suppliers' }} will be asked to quote
    </div>
    <div class="sp-footer__actions">
      <button type="button" class="sp-btn sp-btn--ghost" (click)="onboard.emit()">
        <mat-icon>person_add</mat-icon>
        Onboard new
      </button>
      <!-- <button type="button" class="sp-btn sp-btn--ghost" (click)="closePanel()">Cancel</button> -->
      <button type="button" class="sp-btn" (click)="attach()">
        <mat-icon>how_to_reg</mat-icon>
        Attach to RFQ
      </button>
    </div>
  </div>
</div>
